"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isTrue = void 0;
exports.isTrue = (value) => value === true;
//# sourceMappingURL=is-true.js.map